module.exports = __webpack_public_path__ + "static/img/tbxxkt.13fc8f3c.png";